import React, { useState, useContext, useEffect} from "react";

import { AppContext } from "../../AppContext";

import { fetchCall } from "../../common/FetchHelpers";


import DateUtil from "../../common/dateUtil";

import GiftFormComp from "./GiftFormComp";
import GiftPreviewComp from "./GiftPreviewComp";

const GiftEditorComp = (props) => {

  const reqUrl = "api/gift/create";

  const emptyFormData = {
    id:-1,
    status:"",
    giftType : "Gift",
    description : "",
    giftDate : "",
    address : "",
    giftValue:"",
    currency:"",
    recipients:"",
    providers:"",
    governmentRecipients:"",
    raffleContest:"",
    attachment:null,
    isGovRecipients:"N",
    isRaffleContest:"N",
    submittedFor:null
  }

  const [appContext, setAppContext] = useContext(AppContext);
  const [showError, setShowError] = useState(false);

  const [showEditor, setShowEditor] = useState(true);
  const [showPreview, setShowPreview] = useState(false);

  const [detailMode, setDetailMode] = useState("PREVIEW");


  const [formData, updateFormData] = useState(props.formData);

  const handleChange = (e) => {

    if(e.target.name === 'submittedFor') {
      updateFormData({...formData, [e.target.name]: e.target.value, submittedForLabel: e.target.label});
    } else {
        const value = (e.target.files && e.target.files[0])?e.target.files[0]:e.target.value;
        updateFormData({...formData, [e.target.name]:value});
      }
  };

  const handleDateChange = (date) => {
    updateFormData({
      ...formData,
      giftDate: date
    });
  };

  const handleSaveClick = () => {
      setShowEditor(false);
      setShowPreview(true);
    
  };

  const handleSubmit = () => {
    if (detailMode == "PREVIEW") {
      setDetailMode("POSTREVIEW");

      console.log(formData);

      let giftDate = DateUtil.toStrDate(formData.giftDate);

      const fData = new FormData();

      fData.append("id",formData.id);
      fData.append("status",formData.status);
      fData.append("giftType",formData.giftType);
      fData.append("description",formData.description);
      fData.append("giftDate",giftDate);
      if(formData.address)
        fData.append("address",formData.address);
      fData.append("giftValue",formData.giftValue);
      if(formData.currency)
        fData.append("currency",formData.currency);
      fData.append("recipients",formData.recipients);
      if(formData.providers)
        fData.append("providers",formData.providers);
      fData.append("governmentRecipients",formData.governmentRecipients);
      fData.append("raffleContest",formData.raffleContest);
      fData.append("file",formData.attachment);

      if(formData.submittedFor)
        fData.append("submittedFor",formData.submittedFor);
      
      const reqOptions = {
        method: "POST",
        body: fData
      };

      fetchCall(reqUrl, reqOptions)
        .then((result)=>{
          if(props.editorMode === "NEW"){
            setAppContext({ ...appContext, reloadSummary: true });
          }
          setDetailConfig({
            ...detailConfig,
            detailMode:"POSTREVIEW",
            title: "Request submitted",
            status: {
              state: "success",
              message: "Request successfully submitted",
            },
            btnOk: {
              ...detailConfig.btnOk,
              label: "Add Another request",
            },
            btnCancel: {
              label: "Close",
              handler: props.handleClose,
            },
          });
        })
        .catch((err)=>{
          console.log("Error, with message:", err.statusText);
          setShowEditor(false);
          setShowPreview(false);
          setShowError(true);
        }
      );

    } else {
      console.log("Add Another Clicked");
      handleAddAnother();
    }
  };

  const handleClosePreview = () => {

    setShowEditor(true);
    setShowPreview(false);
  };


  const handleAddAnother = () => {
    setDetailMode("PREVIEW");
    setDetailConfig(defaultConfig);
    updateFormData(emptyFormData);
    handleClosePreview();
  };



  const defaultConfig = {
    editorMode:props.editorMode,
    detailMode:detailMode,
    title: "Review your request before submitting",
    status: {
      state: "",
      message: "",
    },
    btnOk: {
      label: "Submit",
      handler: handleSubmit,
    },
    btnCancel: {
      label: "Edit Before Submit",
      handler: handleClosePreview,
    },
  };
  const [detailConfig, setDetailConfig] = useState(defaultConfig);


  return (
    <>
      {showPreview && (
        <GiftPreviewComp
          config={detailConfig}
          data={formData}
          btnOk={{
            label: detailConfig.btnOk.label,
            handler: handleSubmit,
          }}
        />
      )}

      {showEditor && (<GiftFormComp
        editorMode={props.editorMode}
        data={formData}
        handleChange={handleChange}
        handleDateChange={handleDateChange}
        handleSaveClick={handleSaveClick}
        handleCancel={props.handleClose}

      />)}
      



    </>
  );
};
export default GiftEditorComp;
